import DonatesItems from "../../../components/donates/Donate-items";
import DonatesContainer from "../../../components/donates/Donates-container";
import Form from "../../../components/form/Form";
import {
  getDonates,
  updateDonate,
  deleteDonate,
} from "../../../apis/donatesApi";
import { useState, useEffect } from "react";
import Error from "../../../components/errors-messages/Error";

import React from "react";

// import "./NavigationItems.css";

function Donates(props) {
  const [state, setState] = useState({
    isEditing: false,
    donates: [],
    editDonate: null,
    error: null,
  });

  useEffect(() => {
    loadPosts();
    // const socket = openSocket("https://shark-app-2ttko.ondigitalocean.app/website");

    // socket.on("posts", (data) => {
    //   if (data.action === "create") {
    //     addPost(data.post);
    //   } else if (data.action === "update") {
    //     updatePost(data.post);
    //   } else if (data.action === "delete") {
    //     loadPosts();
    //   }
    // });
  }, []);

  const loadPosts = async () => {
    const { data, error } = await getDonates();
    if (!data && error) {
      return setState((prevState) => {
        return {
          isEditing: false,
          donates: [],
          editDonate: null,
          error: error,
        };
      });
    }
    setState((prevState) => {
      return {
        ...prevState,
        donates: data.donates,
      };
    });
  };

  const startEditPostHandler = (postId) => {
    setState((prevState) => {
      const loadedDonate = {
        ...prevState.donates.find((p) => p._id === postId),
      };

      return {
        ...prevState,
        isEditing: true,
        editDonate: loadedDonate,
      };
    });
  };

  const cancelEditHandler = () => {
    setState((prevState) => {
      return { ...prevState, isEditing: false, editDonate: null, error: null };
    });
  };

  const finishEditHandler = async (donateData) => {
    setState((prevState) => {
      return {
        ...prevState,
        editLoading: true,
      };
    });
    // Set up data (with image!)

    // const formData = new FormData();

    // formData.append("type", postData.type);
    // formData.append("name", postData.name);
    // formData.append("image", postData.image);
    let donateId = state.editDonate ? state.editDonate._id : null;
    const { data, error } = await updateDonate(
      props.token,
      donateId,
      donateData
    );

    if (!data && error) {
      return setState((prevState) => {
        return {
          ...prevState,
          isEditing: false,
          editDonate: null,
          // editLoading: false,
          error: error,
        };
      });
    }

    // const updatedDonate = resData.donate;
    const donate = {
      _id: data.donate._id,
      type: data.donate.type,
      name: data.donate.name,
      link: data.donate.link,
    };

    setState((prevState) => {
      // console.log(prevState.donates.concat(donate));
      let updatedDonates;
      if (prevState.editDonate) {
        updatedDonates = prevState.donates.map((c) =>
          c._id === donate._id ? donate : c
        );
      } else {
        updatedDonates = prevState.donates.concat(donate);
      }
      return {
        ...prevState,
        donates: updatedDonates,
        isEditing: false,
        editDonate: null,
        // editLoading: false,
      };
    });
  };

  const newPostHandler = () => {
    setState((prevState) => {
      return { ...prevState, isEditing: true };
    });
  };

  const deletePostHandler = async (postId) => {
    setState((prevState) => {
      return { ...prevState, postsLoading: true };
    });

    const { data, error } = await deleteDonate(props.token, postId);

    if (!data && error) {
      return setState((prevState) => {
        return {
          ...prevState,
          isEditing: false,
          editDonate: null,
          // editLoading: false,
          error: error,
        };
      });
    }
    loadPosts();
    return setState((prevState) => {
      return { ...prevState, postsLoading: false };
    });
    // setState((prevState) => {
    //   const updatedPosts = prevState.posts.filter((p) => p._id !== postId);
    //   return { posts: updatedPosts, postsLoading: false };
    // });
  };

  return (
    <>
      <Error error={state.error} onHandle={cancelEditHandler} />
      <Form
        editing={state.isEditing}
        currentItem={state.editDonate}
        page={"Donate"}
        // loading={state.editLoading}
        onCancelEdit={cancelEditHandler}
        onFinishEdit={finishEditHandler}
      />
      <DonatesContainer onAddDonate={newPostHandler} isAuth={props.isAuth}>
        {state.donates.map((donate) => (
          <DonatesItems
            onStartEdit={startEditPostHandler.bind(this, donate._id)}
            key={donate._id}
            type={donate.type}
            name={donate.name}
            onDelete={deletePostHandler.bind(this, donate._id)}
            isAuth={props.isAuth}
          />
        ))}
      </DonatesContainer>
      ;
    </>
  );

  // props.isAuth && (
  //   <li className="navigation-item" key="logout">
  //     <button onClick={props.onLogout}>Logout</button>
  //   </li>
  // ),
}

export default Donates;
